module.exports = __webpack_public_path__ + "img/4.3bb3364.png";